module.exports = __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/dish@2x-f541fbfe7aeaa1f6a90fa2e2ad4f2021.png";